<script setup lang="ts">
import InputSwitch from "primevue/inputswitch";

const props = withDefaults(
  defineProps<{
    label: string;
    description?: string;
    modelValue: boolean;
  }>(),
  {
    description: undefined,
    modelValue: false,
  },
);

const emit = defineEmits<(e: "update:modelValue", value: boolean) => void>();
</script>

<template>
  <div class="flex items-center gap-4">
    <div class="flex-1">
      <div class="text-sm text-slate-700">{{ label }}</div>
      <div v-if="description" class="text-xs text-gray-500 mt-1">{{ description }}</div>
    </div>
    <InputSwitch :model-value="props.modelValue" @update:model-value="(val) => emit('update:modelValue', val)" />
  </div>
</template>
